<div class="py-2">
  <div class="p-3 border border-dark-subtle rounded-4 cursor-pointer zoom-shadow">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="d-flex justify-content-start align-items-center gap-2">
        <ng-container *ngIf="data?.unitTypeId === UnitTypes.HEATING">
          <i class="ri-fire-line text-warning fw-bolder fs-22"></i>
          <span class="text-muted fs-22">{{ 'METER.WARMTH' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="data?.unitTypeId === UnitTypes.WARM_WATER">
          <i class="ri-contrast-drop-line text-danger fw-bolder fs-22"></i>
          <span class="text-muted fs-22">{{ 'METER.WARM_WATER' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="data?.unitTypeId === UnitTypes.COLD_WATER">
          <i class="ri-contrast-drop-2-line text-secondary fw-bolder fs-22"></i>
          <span class="text-muted fs-22">{{ 'METER.COLD_WATER' | translate }}</span>
        </ng-container>
        <span class="py-0 px-2 bg-dark-subtle fw-bolder rounded-4">
          {{ data?.apartmentId ? translateService.instant('METER.UNIT_TYPE') : translateService.instant('METER.MAIN_BUILDING') }}
        </span>
      </div>

      <i
        class="py-0 px-2 rounded-3 fs-22 fw-bolder"
        [class]="data?.connectivityStatus == 'Online' || data?.connectivityStatus === 'online' ? 'ri-check-line bg-primary-subtle text-primary' : 'ri-close-line text-danger bg-danger-subtle'">
      </i>
    </div>

    <p class="fw-bolder p-0 m-0 fs-18">{{ data?.name || '-' }}</p>
    <p class="text-muted p-0 m-0 fs-16">{{ apartment || translateService.instant('METER.MAIN_BUILDING') }}, {{ data?.installationLocation || '-' }}</p>

    <div class="d-flex align-items-center gap-2 text-muted border-top border-bottom py-2 my-2">
      <i class="ri-building-line fs-22"></i>
      <h3 class="p-0 m-0 fs-18">{{ property }}</h3>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="text-muted fs-18">{{ 'METER.CURRENT_VALUE' | translate }}</span>
      <span class="fw-bolder fs-18">{{ data?.lastReadingValue ? data?.lastReadingValue + ' m³' : '-' }}</span>
    </div>

    <p class="text-muted fs-18">
      {{ 'METER.LAST_UPDATED' | translate }}:
      <span *ngIf="data?.lastReadingDate">{{ data?.lastReadingDate | date }}</span>
      <span *ngIf="!data?.lastReadingDate">-</span>
    </p>
  </div>
</div>
